export default
/* glsl */
"\n#ifdef USE_COLOR\n\n\tvarying vec3 vColor;\n\n#endif\n";